import { createFileRoute, redirect } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'

export const missionCompatibilityTarget = '/punktacja' as const

export const Route = createFileRoute('/_panel/misje/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'admin' && me.data.role !== 'superadmin') {
      throw redirect({ to: '/' })
    }
    throw redirect({ to: missionCompatibilityTarget })
  },
})
